import {createApp} from 'vue';
import App from './App.vue';

// 服务形式组件样式（按需组件由 unplugin-vue-components 处理）
import 'element-plus/theme-chalk/src/message.scss';
import 'element-plus/theme-chalk/src/message-box.scss';

const app = createApp(App);
app.mount('#app');
